/* @flow */
import { Record } from 'immutable';

export const SUBSCRIPTIONS_ENDPOINT = '/services/subscriptions';

export const Subscription = Record({
  feedGuid: null,
  enclaveGuid: null,
  companyGuid: '',
  state: null,
  lastPulled: null,
  created: null,
  updated: null,
});



// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/types.js